import { createSlice } from "@reduxjs/toolkit";
import { downloadMemoir, fetchMemoirs } from "./action";
const initialState = {
  memoirs: {
    success: null,
    loading: false,
    list: [],


  },
  listData: {
    list: null,
    count: 0,
    loading: false,
    downloadingId: null,
  }
};

const memoirSlice = createSlice({
  name: "memoirs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(fetchMemoirs.pending, (state) => {
      state.listData.loading = true;
    });
    builder.addCase(fetchMemoirs.fulfilled, (state, action) => {
      state.listData.loading = false;

      if (action.payload?.success) {
        state.listData.list =
          action.payload?.data?.memoirs?.length > 0 ? action.payload?.data?.memoirs : [];
        state.listData.count = action.payload?.data?.pagination?.total || 0;
      } else {
        state.listData.list = [];
        state.listData.count = 0;
      }
    });


    builder.addCase(fetchMemoirs.rejected, (state) => {
      state.listData.loading = false;
    });
    builder.addCase(downloadMemoir.pending, (state, action) => {
      state.listData.downloadingId = action.meta.arg;
    });

    builder.addCase(downloadMemoir.fulfilled, (state) => {
      state.listData.downloadingId = null;
    });

    builder.addCase(downloadMemoir.rejected, (state) => {
      state.listData.downloadingId = null;
    });

  },
});


export default memoirSlice.reducer;
